import { render, staticRenderFns } from "./two.vue?vue&type=template&id=74703837&scoped=true"
import script from "./two.vue?vue&type=script&lang=ts"
export * from "./two.vue?vue&type=script&lang=ts"
import style0 from "./two.vue?vue&type=style&index=0&id=74703837&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74703837",
  null
  
)

export default component.exports